<template>
    <div class="modal modal-slide-in fade" id="add-new-debt-collector-sidebar" aria-hidden="true">
        <div class="modal-dialog sidebar-lg">
            <div class="modal-content p-0">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">×</button>
                <div class="modal-header mb-1">
                    <h5 class="modal-title">
                        <span class="align-middle">Add Debt Collector</span>
                    </h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <div class="form-group">
                        <label for="customer-name" class="form-label">
                            {{ localizationStore.translate('name') }}
                        </label>
                        <input 
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': vuelidate.creditorName.$error }"
                            v-model="creditorName"
                            :placeholder="localizationStore.translate('name.placeholder')"
                        />
                        <template v-if="vuelidate.creditorName.$error">
                            <span v-if="vuelidate.creditorName.required" class="invalid-feedback" role="alert">
                                <strong>{{ vuelidate.creditorName.required.$message }}</strong>
                            </span>
                        </template>
                    </div>
                    <div class="form-group">
                        <label for="customer-address" class="form-label">
                            {{ localizationStore.translate('address.line') }}
                        </label>
                        <textarea
                            class="form-control"
                            :class="{ 'is-invalid': vuelidate.addressLine.$error }"
                            v-model="addressLine"
                            cols="2"
                            rows="2"
                            :placeholder="localizationStore.translate('address.line.placeholder')"
                        ></textarea>
                        <template v-if="vuelidate.addressLine.$error">
                            <span v-if="vuelidate.addressLine.required" class="invalid-feedback" role="alert">
                                <strong>{{ vuelidate.addressLine.required.$message }}</strong>
                            </span>
                        </template>
                    </div>
                    <div class="form-group">
                        <label class="form-label" for="city">
                            {{ localizationStore.translate('city') }}
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': vuelidate.city.$error }"
                            :placeholder="localizationStore.translate('city.placeholder')"
                            v-model="city"
                            aria-label=""
                            :aria-describedby="localizationStore.translate('city')"
                        />
                        <template v-if="vuelidate.city.$error">
                            <span v-if="vuelidate.city.required" class="invalid-feedback" role="alert">
                                <strong>{{ vuelidate.city.required.$message }}</strong>
                            </span>
                        </template>
                    </div>
                    <div class="form-group">
                        <label class="form-label" for="state">
                            {{ localizationStore.translate('state') }}
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': vuelidate.state.$error }"
                            v-model="state"
                            :placeholder="localizationStore.translate('state.placeholder')"
                            aria-label=""
                            :aria-describedby="localizationStore.translate('state')"
                        />
                        <template v-if="vuelidate.state.$error">
                            <span v-if="vuelidate.state.required && vuelidate.state.required.$invalid" class="invalid-feedback" role="alert">
                                <strong>{{ vuelidate.state.required.$message }}</strong>
                            </span>
                            <span v-else-if="vuelidate.state.maxLength && vuelidate.state.maxLength.$invalid" class="invalid-feedback" role="alert">
                                <strong>{{ vuelidate.state.maxLength.$message }}</strong>
                            </span>
                        </template>
                    </div>
                    <div class="form-group">
                        <label class="form-label" for="zipcode">
                            {{ localizationStore.translate('zipcode') }}
                        </label>
                        <input
                            type="number"
                            class="form-control"
                            :class="{ 'is-invalid': vuelidate.zipcode.$error }"
                            :placeholder="localizationStore.translate('zipcode.placeholder')"
                            v-model="zipcode"
                            aria-label=""
                            :aria-describedby="localizationStore.translate('zipcode')"
                        />
                        <template v-if="vuelidate.zipcode.$error">
                            <span v-if="vuelidate.zipcode.required && vuelidate.zipcode.required.$invalid" class="invalid-feedback" role="alert">
                                <strong>{{ vuelidate.zipcode.required.$message }}</strong>
                            </span>
                            <span v-else-if="vuelidate.zipcode.integer && vuelidate.zipcode.integer.$invalid" class="invalid-feedback" role="alert">
                                <strong>{{ vuelidate.zipcode.integer.$message }}</strong>
                            </span>
                        </template>
                    </div>
                    <div class="form-group">
                        <label for="customer-contact" class="form-label">Contact</label>
                        <phone-input-component
                            @phoneInput="updatePhone"
                            name="phone"
                            :prop-phone="phone"
                        ></phone-input-component>
                    </div>
                    <div class="form-group d-flex flex-wrap mt-2">
                        <button @click="createDebtCollector" type="button" class="btn btn-primary mr-1">
                            Add
                        </button>
                        <button ref="closeModalButton" type="button" class="btn btn-outline-secondary" data-dismiss="modal">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useLocalizationStore } from '../stores/LocalizationStore.js'
    import useVuelidate from '@vuelidate/core'
    import { required, maxLength, integer } from '@vuelidate/validators'
    import { ref, reactive } from 'vue'
    export default {
        name: 'debt-collector-form',
        mounted() {
        },
        setup() {
            const creditorName = ref(''),
            addressLine = ref(''),
            city = ref(''),
            state = ref(''),
            zipcode = ref(''),
            phone = ref(''),
            rules = reactive(
                {
                    creditorName: {
                        required
                    },
                    addressLine: {
                        required
                    },
                    city: {
                        required
                    },
                    state: {
                        required,
                        maxLength: maxLength(2)
                    },
                    zipcode: {
                        required,
                        integer
                    }
                }
            );
            return {
                localizationStore: useLocalizationStore(),
                creditorName,
                addressLine,
                city,
                state,
                zipcode,
                phone,
                vuelidate: useVuelidate(rules, { creditorName, addressLine, city, state, zipcode }),
            }
        },
        methods: {
            async createDebtCollector() {
                const isValidForm = await this.vuelidate.$validate();
                if (isValidForm) {
                    let params = {};
                    if (this.$route.params && this.$route.params.client) {
                        params.client = this.$route.params.client;
                    }
                    let $this = this;
                    const route = this.$router.resolve(
                        {
                            name: 'invoice-add-debt-collector',
                            params: params
                        }
                    );
                    axios.post(
                        route.href,
                        {
                            creditor_name: this.creditorName,
                            address_line: this.addressLine,
                            city: this.city,
                            state: this.state,
                            zipcode: this.zipcode,
                            phone: this.phone,
                            address: `${this.addressLine} ${this.city},${this.state}${this.zipcode}`
                        }
                    ).then(function(response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        toastr.success(response.data.message, 'Success!');
                        $this.$refs.closeModalButton.click();
                        $this.resetForm();
                        return;
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    });
                }
            },
            updatePhone(phone) {
                this.phone = phone;
            },
            resetForm() {
                this.creditorName = this.addressLine = this.city = this.state = this.zipcode = this.phone = '';
            }
        }
    }
</script>
